import { Rocket } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { cn } from "@/lib/utils";

const PublishButton = ({ isNeedPublish, setConfirmModal, confirmPublish, setActiveTab, setShouldLoadQna, showIndicator, size, className }: any) => {

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const goToFAQTab = () => {
      setConfirmModal({ show: false });
      setShouldLoadQna(true);
      setActiveTab("faq");
    };

    const goToPropertyInfo = () => {
      setConfirmModal({ show: false });
      setActiveTab("property");
    };

    if (!isNeedPublish) {
      setConfirmModal({
        show: true,
        title: "Please make changes before publishing.",
        label: "Please make changes before publishing.",
        confirmText: "Okay",
        cancelText: "Cancel",
        onConfirm: goToPropertyInfo,
        onClose: goToPropertyInfo,
      });
    } else {
      let confirmed = false;
      setConfirmModal({
        show: true,
        title: "Confirm Publish",
        label: "Have you completed updating the Bot?",
        confirmText: "Yes, Publish",
        cancelText: "I still need to add more content",
        onConfirm: async () => {
          confirmed = true;
          goToPropertyInfo();
          await confirmPublish();
        },
        // PublishModal also calls onClose after onConfirm.
        onClose: () => {
          if (!confirmed) goToFAQTab();
        },
      });
    }
  };

  return (
    <Button
      type="button"
      variant={isNeedPublish ? "default" : "outline"}
      size={size}
      className={cn("relative w-full", className)}
      onClick={handleClick}
    >
      {isNeedPublish && showIndicator && (
        <span className="absolute -right-1 -top-1 flex size-3" aria-hidden="true">
          <span className="absolute inline-flex size-full animate-ping rounded-full bg-destructive opacity-75" />
          <span className="relative inline-flex size-3 rounded-full border-2 border-background bg-destructive" />
        </span>
      )}
      <Rocket aria-hidden="true" />
      Publish
      {isNeedPublish && <span className="sr-only"> (unpublished changes)</span>}
    </Button>
  );
};

export default PublishButton;
